import { Permission, RoleSlug, User, PermissionRight } from '../queries/api/types';

export const hasPermission = (user?: User, permission?: Permission, right: PermissionRight = PermissionRight.read) => {
    if (!permission || user?.mergedPermissions?.[Permission.superAdmin] === PermissionRight.write) {
        return true;
    }
    switch (right) {
        case PermissionRight.read:
            return Boolean(user?.mergedPermissions?.[permission]);
        case PermissionRight.write:
            return user?.mergedPermissions?.[permission] === PermissionRight.write;
    }
    return false;
};

export const hasRole = (user?: User, roles?: RoleSlug[]) => {
    return user?.role?.slug && roles?.includes(user.role.slug);
};
